export enum UIButtonMode {
    default,
    primary,
    critical,
    warning,
    success,
    highlight
}